<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00084 6.35117L13.7758 0.576172L15.4255 2.22584L9.6505 8.00084L15.4255 13.7758L13.7758 15.4255L8.00084 9.6505L2.22584 15.4255L0.576172 13.7758L6.35117 8.00084L0.576172 2.22584L2.22584 0.576172L8.00084 6.35117Z"
      :fill="color" :fill-opacity="fillOpacity" />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconCross',
  components: {
  },
  props: {
    color: {
      default: '#222',
      type: String
    },
    height: {
      default: '12',
      type: String
    },
    width: {
      default: '12',
      type: String
    },
    fillOpacity: {
      default: '0.87',
      type: String
    }
  }
})
export default class extends Vue {

}
</script>

<style scoped>
</style>
